import cx from 'classnames'

export function TableRowHeader({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) {
  return <th className={cx('table-row-header', className)}>{children}</th>
}
